/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  ErrorInfo,
  Notifications,
  PostDeleteNotificationsBody
} from '.././model'


/**
 * 通知テーブルからログインユーザーの通知件数を取得して返す。

 * @summary 通知件数取得
 */
export const getNotificationsCount = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    return axios.get(
      `/notifications/count`,options
    );
  }


export const getGetNotificationsCountQueryKey = () => [`/notifications/count`];

    
export type GetNotificationsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationsCount>>>
export type GetNotificationsCountQueryError = AxiosError<ErrorInfo>

export const useGetNotificationsCount = <TData = Awaited<ReturnType<typeof getNotificationsCount>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationsCount>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsCountQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsCount>>> = ({ signal }) => getNotificationsCount({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getNotificationsCount>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 通知テーブルからログインユーザーの通知一覧を取得して返す。

 * @summary 通知一覧取得
 */
export const getNotifications = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Notifications>> => {
    return axios.get(
      `/notifications`,options
    );
  }


export const getGetNotificationsQueryKey = () => [`/notifications`];

    
export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>
export type GetNotificationsQueryError = AxiosError<ErrorInfo>

export const useGetNotifications = <TData = Awaited<ReturnType<typeof getNotifications>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotifications>>> = ({ signal }) => getNotifications({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getNotifications>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 通知テーブルからログインユーザーの通知一覧を削除する。

 * @summary 通知一覧削除
 */
export const postDeleteNotifications = (
    postDeleteNotificationsBody: PostDeleteNotificationsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/notifications`,
      postDeleteNotificationsBody,options
    );
  }



    export type PostDeleteNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof postDeleteNotifications>>>
    export type PostDeleteNotificationsMutationBody = PostDeleteNotificationsBody
    export type PostDeleteNotificationsMutationError = AxiosError<ErrorInfo>

    export const usePostDeleteNotifications = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDeleteNotifications>>, TError,{data: PostDeleteNotificationsBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDeleteNotifications>>, {data: PostDeleteNotificationsBody}> = (props) => {
          const {data} = props ?? {};

          return  postDeleteNotifications(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postDeleteNotifications>>, TError, {data: PostDeleteNotificationsBody}, TContext>(mutationFn, mutationOptions)
    }
    